import * as methods from '../methods';
import { Resource } from '../Resource';
import * as transformers from '../transformers';
const rootPath = 'organization_networks';
export const fromRaw = {
    get: (raw) => {
        return {
            id: raw.id,
            network: raw.network,
            orgId: raw.organization,
            since: raw.since,
            until: raw.until,
            owner: raw.owner
        };
    }
};
/**
 * information about the network from the perspective of organization
 */
const orgNetworks = Resource((requesterBuilder) => {
    const getMany = (query) => requesterBuilder({
        path: rootPath,
        requestCtx: {
            transform: transformers.paginatedResponse(fromRaw.get),
            params: {
                query: {
                    limit: query?.limit,
                    offset: query?.offset,
                    active: query?.active,
                    organization: query?.orgId
                }
            }
        }
    });
    return {
        getMany,
        get: methods.get({ requesterBuilder, rootPath, fromRaw: fromRaw.get }),
        getAll: methods.getAllPages({ getMany }),
        getPage: methods.getPage({ getMany }),
        leave: (id) => requesterBuilder({
            path: `${rootPath}/${id}/leave`,
            requestCtx: {
                parse: async (x) => x,
                method: 'POST'
            },
            keysToInvalidate: [getMany().invalidationKey]
        })
    };
});
export default orgNetworks;
